import React from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";

// Routes the page without any authentication by the user
const CommonRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
      <Component {...props} />
  )} />
);

// Define Props Types
CommonRoute.propTypes = {
  component: PropTypes.elementType
};

export default CommonRoute;
